module.exports = __webpack_public_path__ + "img/asset-2.dad8b4fa.png";